import { CancelToken } from 'axios';

import shortid from 'shortid';
import { API_URL } from '../config/config';
import BaseRequest from '../http-requests/BaseRequest';

const ServiceBaseUrl = `${API_URL}/advanced-search`;

export const getFilterOptions = (
    id: string | null,
    id_biblioteca: string | null,
    id_colecao: string | null,
    tipo_obra: string | null,
    cancelToken?: CancelToken,
) => {
    return BaseRequest.axiosInst.get(`${ServiceBaseUrl}/options`, {
        headers: BaseRequest.publicHeaders,
        cancelToken,
        params: {
            id,
            id_biblioteca,
            id_colecao,
            tipo_obra,
        },
    });
};
